import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.li`
  display: block;
  width: 100%;
`;

export const LogoBox = styled.div`
  content: '';
  display: flex;
  position: absolute;
  top: 50%;
  left: 6%;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
`;

export const SNSButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    padding: 8px;
    transition: filter 0.1s ease;
    border-radius: 22px;

    img {
      width: 22px;
      height: 22px;
    }

    strong {
      ${theme.fontStyle.text.body18_medium}
    }

    &#Google {
      border: 1px solid ${theme.stroke.stroke_2};
      background: ${theme.backgroundColor.bg_light_1};

      strong {
        color: ${theme.content.content_dark_1};
      }

      i {
        color: ${theme.themeColor.main_2};
      }
    }

    &#Apple {
      border: 1px solid ${theme.stroke.stroke_1};
      background: ${theme.backgroundColor.bg_dark_2};

      strong {
        color: ${theme.content.content_light_1};
      }

      i {
        color: ${theme.themeColor.basic};
      }
    }

    &:hover {
      filter: brightness(0.9);
    }
  `}
`;

export const LoadingSpinner = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  animation: rotation 1.3s infinite linear;

  @keyframes rotation {
    to {
      transform: rotate(1turn);
    }
  }

  & > svg {
    width: 100%;
    height: 100%;
  }
`;
